

// @ts-nocheck

import Vue from "vue";

import info from "./SVGs/Info.vue";
import globe from "./SVGs/Globe.vue"
import coupon from "./SVGs/Coupon.vue"

export default Vue.extend({
  data() {
    return {
      eLinksLocal: [] as any[],
      placeholderIdeas: [
        {
          text: "Here’s a 10% off coupon",
          url: "https://yoursite.com/coupon"
        },
        {
          text: "Check out our latest promotion!",
          url: "https://yoursite.com/promotion"
        },
        {
          text: "Are you following our blog?",
          url: "https://yoursite.com/blog"
        }
      ]
    };
  },
  props: {
    fieldAddress: Array,
  },
  computed: {
    links: {
      get: function (): string | false {
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: any[] | false): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  components: {
    info,
    globe,
    coupon
  },
  methods: {
    changePic(i: number, picSource: string): void {
    // @ts-ignore
      this.eLinksLocal[i].picSource = picSource;
    },
    addLink(): void {
      this.eLinksLocal.push({        
        picSource: "globe",
        url: "",
        onlyVideo: false,
        text: ""
      });
    },
    removeLink(i: number) {
      this.eLinksLocal.splice(i, 1);
    }
  },
  created() {

    if (this.links === false) {
      this.eLinksLocal = [];
    } else {
      this.eLinksLocal = [...this.links];
    }
    // @ts-ignore    

  },
  watch: {
    eLinksLocal: {
      handler(v) {

        this.links = JSON.parse(JSON.stringify(this.eLinksLocal))
        setTimeout(() => {
          // @ts-ignore //errors not picked up
          if (this.errors.any()) {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
          } else {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
          }
        }, 1);
      },
      deep: true,
    },
  },
});
